import React from 'react';

import PropTypes from 'prop-types';
import { Input, Form } from 'semantic-ui-react';

import { EXTRA_DATA_TYPES } from './ExtraDataForm.constants';
import { ExtraAttributePropType } from '../ExtraDataGroupForm/ExtraDataGroupForm.types';

import './ExtraDataForm.scss';

const propTypes = {
  data: ExtraAttributePropType.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default function ExtraDataForm({ data, onChange, onRemove }) {
  function handleChange(field, value) {
    onChange({ ...data, [field]: value });
  }

  return (
    <Form.Group className="extra-data-item">
      <Form.Select
        label="Type"
        value={data.type}
        onChange={(e, { value }) => handleChange('type', value)}
        options={EXTRA_DATA_TYPES}
        width={3}
      />
      <Form.Field width={3}>
        <label htmlFor="icon-input">Icon</label>
        <Input
          id="icon-input"
          placeholder="Icon"
          value={data.icon}
          onChange={(e, { value }) => handleChange('icon', value)}
        />
        <small>
          Pick any icon from{' '}
          <a href="https://react.semantic-ui.com/elements/icon/" target="_blank" rel="noreferrer">
            Semantic UI
          </a>
        </small>
      </Form.Field>
      <Form.Input
        label="Label"
        placeholder="Label"
        value={data.label}
        onChange={(e) => handleChange('label', e.target.value)}
        width={4}
      />
      <Form.Field>
        <label htmlFor="description-input">Description</label>
        <Input
          id="description-input"
          placeholder="Description"
          value={data.description}
          onChange={(e) => handleChange('description', e.target.value)}
          width={5}
        />
        <small className="helper">
          You can use basic markdown as <b>**bold**</b>, <i>*italic*</i> or
          [link](https://example.com) for a named link.
        </small>
      </Form.Field>
      <Form.Button className="delete-button" icon="trash" onClick={onRemove} width={1} />
    </Form.Group>
  );
}

ExtraDataForm.propTypes = propTypes;
